const stringPattern = /(?:\d{4}[ -]?){4}(?=(?!\d))/gm;

export default (value) => (value.replace(stringPattern, '****'));
